<ng-template #origemBalao></ng-template>
@if (mostrarBalao() && alertaDoBalao(); as alerta) {
  <div class="ai-teaser" role="status">
    <button class="ai-teaser-fechar" (click)="fecharBalao()" aria-label="Fechar aviso">
      <mat-icon>close</mat-icon>
    </button>
    <button class="ai-teaser-corpo" type="button" (click)="abrir()">
      <mat-icon>auto_awesome</mat-icon>
      <span>{{ alerta.titulo }}</span>
    </button>
  </div>
}

@if (mostrarBalaoAjuda()) {
  <div class="ai-teaser" role="status">
    <button class="ai-teaser-fechar" (click)="fecharBalaoAjuda()" aria-label="Fechar aviso">
      <mat-icon>close</mat-icon>
    </button>
    <button class="ai-teaser-corpo" type="button" (click)="abrirAjudaTela()">
      <mat-icon>help_outline</mat-icon>
      <span>Precisa de ajuda com esta tela?</span>
    </button>
    @if (guia.trechoAtual()) {
      <button class="ai-teaser-corpo" type="button" data-test="idle-tour" (click)="mostrarTourDaTela()">
        <mat-icon>tour</mat-icon>
        <span>Mostrar no tour</span>
      </button>
    }
  </div>
}

<!-- Cinto e suspensório (review Task 4→5): a arbitração D76 já exige !ai.aberto() por dentro,
     mas o oculto some por construção mesmo se essa checagem um dia divergir do svc.aberto(). -->
<guia-teaser [oculto]="mostrarBalao() || svc.aberto()" />

<!-- Aba-gaveta (fechada + autenticado, OU aberta e acoplada — spec §5). `temUsuario` chega como
     @Input (review Task 6, Critical 1): este overlay é Default-CD, então `temUsuario()` (que lê
     UnifiedAuthService, não reativo) é relido a cada ciclo — e a escrita do @Input marca a aba
     (OnPush) para checagem mesmo quando aberto()/acoplado() não mudam (ex.: login em runtime). -->
<!-- `--ai-accent` no host (display: contents) herda para a minhoca e o brilho da chamada. -->
<ai-aba [temUsuario]="temUsuario()" [chamando]="chamandoAba()" [disparo]="disparoAba()"
        [style.--ai-accent]="accent" (abrir)="abrir()" />

@if (svc.aberto() && !layout.acoplado()) {
  <!-- animate.leave (Angular 20.2+): ao fechar, a view fica no DOM com `ai-overlay-sai` até a
       animação mais longa DESTE elemento terminar — o chat volta para a aba (gênio), o palco desce
       com fade (ai-assistant-overlay.component.css). -->
  <div class="ai-overlay" animate.leave="ai-overlay-sai"
       [style.--ai-accent]="accent" [attr.data-estado]="svc.estado()" [class.is-chat-mode]="emChat()">
    <div class="ai-scrim" (click)="fechar()"></div>

    <!-- O --ai-accent inline REPETE aqui o do .ai-overlay de propósito: sem este override, a cor
         da marca parava no pai e o palco voltava ao --main do sistema. -->
    <section class="ai-stage" [style.--ai-accent]="accent"
             role="dialog" aria-modal="true" aria-label="Assistente One">
      <header class="ai-top">
        <span class="ai-brand"><mat-icon>auto_awesome</mat-icon> Assistente</span>
        <div class="ai-top-actions">
          <one-icon-button [icon]="svc.mutado() ? 'volume_off' : 'volume_up'" [active]="svc.mutado()"
                           [ariaLabel]="svc.mutado() ? 'Ativar som' : 'Silenciar'" (clicked)="alternarMudo()" />
          <one-icon-button data-test="overlay-acoplar" icon="view_sidebar" ariaLabel="Acoplar à direita"
                           [disabled]="!layout.podeAcoplar()"
                           [title]="layout.podeAcoplar() ? 'Acoplar à direita' : 'Acoplar fica disponível ao terminar o tour ou numa janela mais larga'"
                           (clicked)="acoplar()" />
          <one-icon-button [icon]="emChat() ? 'open_in_full' : 'close_fullscreen'"
                           [ariaLabel]="emChat() ? 'Tela cheia' : 'Modo chat'" (clicked)="alternarModoChat()" />
          <one-icon-button icon="refresh" ariaLabel="Nova conversa" (clicked)="svc.novaConversa()" />
          <one-icon-button icon="close" ariaLabel="Fechar" (clicked)="fechar()" />
        </div>
      </header>

      <div class="ai-orb" [attr.data-estado]="svc.estado()">
        <span class="ai-orb-core"></span>
        <span class="ai-ring ring-1"></span>
        <span class="ai-ring ring-2"></span>
        <span class="ai-ring ring-3"></span>
      </div>
      <p class="ai-estado">{{ rotuloEstado() }}</p>

      <ai-conversa [compacto]="emChat()" />
    </section>
  </div>
}
